<template>
    <v-container style=" height: 100%; overflow-y: scroll">
        <v-row>
            <v-col>
                <v-card class="h-100">
                    <v-card-title>
                        <v-row no-gutters>
                            <v-col>
                                <div class="pupular-card_title">Динамика активации бонусов</div>
                                <div class="pupular-card_subtitle">{{formatDateStartChart}} - {{formatDate(curDate)}}
                                </div>
                            </v-col>
                            <v-col cols="4">
                                <v-select
                                        v-model="lastDayActivations"
                                        hide-details
                                        solo
                                        :items="lastDaysItems"
                                        @change="getDateStartChart"
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text class="h-100">
                        <chartActivations class="h-100" :lastDays="lastDayActivations"></chartActivations>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="auto">
                <v-card class="summary-card">
                    <v-card-title class="summary-card_title">
                        Всего активаций
                    </v-card-title>
                    <v-card-text>
                        <div class="summary-card_label">За день</div>
                        <div class="summary-card_text">{{summary.totalDay}}</div>
                        <div class="summary-card_label">За 30 дней</div>
                        <div class="summary-card_text">{{summary.totalMonth}}</div>
                        <div class="summary-card_label">За год</div>
                        <div class="summary-card_text">{{summary.totalYear}}</div>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card class="popular-card">
                    <v-card-title>
                        <v-row no-gutters>
                            <v-col>
                                <div class="pupular-card_title">Самые популярные партнеры</div>
                                <div class="pupular-card_subtitle">Количество бонусов, активированных у партнера</div>
                            </v-col>
                            <v-col cols="4">
                                <v-select
                                        v-model="lastDayPartners"
                                        hide-details
                                        solo
                                        :items="lastDaysItems"
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="h-100">
                        <popPartnersList limited :lastDays="lastDayPartners"></popPartnersList>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="#0156AD" text plain style="text-transform: none" @click="openDetails(0)">
                            <v-icon>mdi-open-in-new</v-icon>
                            <span class="ml-2">Открыть полный список</span></v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col>
                <v-card class="popular-card">
                    <v-card-title>
                        <v-row no-gutters>
                            <v-col>
                                <div class="pupular-card_title">Самые популярные клиенты</div>
                                <div class="pupular-card_subtitle">Количество бонусов, активированных у партнера</div>
                            </v-col>
                            <v-col cols="4">
                                <v-select
                                        v-model="lastDaysClients"
                                        hide-details
                                        solo
                                        :items="lastDaysItems"
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="h-100">
                        <popClientsList limited :lastDays="lastDaysClients"></popClientsList>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="#0156AD" text plain style="text-transform: none" @click="openDetails(1)">
                            <v-icon>mdi-open-in-new</v-icon>
                            <span class="ml-2">Открыть полный список</span></v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card class="activates-card">
                    <v-card-title>
                        <div class="activates-card_title">История активаций</div>
                    </v-card-title>
                    <v-card-text class="h-100">
                        <activationsList isLimit></activationsList>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="#0156AD" text plain style="text-transform: none" @click="openDetails(2)">
                            <v-icon>mdi-open-in-new</v-icon>
                            <span class="ml-2">Открыть полный список</span></v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>

</template>

<script>
    const chartActivations = () => import("../components/Statistics/ActivationsChart.vue")
    const popPartnersList = () => import("../components/Statistics/PopPartnersList")
    const popClientsList = () => import("../components/Statistics/PopClientsList")
    const activationsList = () => import("../components/Statistics/ActivationsList")

    export default {
        name: "Statistics",
        components: {chartActivations, popPartnersList, popClientsList, activationsList},
        data() {
            return {
                lastDayActivations: 30,
                lastDayPartners: 30,
                lastDaysClients: 30,
                curDate: new Date(),
                dateStartChart: new Date(),
                summary: {
                    totalDay: 0,
                    totalMonth: 0,
                    totalYear: 0
                },
            }
        },
        mounted() {
            this.getDateStartChart()
            this.getActivationSummary()
        },
        computed: {
            lastDaysItems() {
                return [
                    {value: 30, text: "Последние 30 дней"},
                    {value: 7, text: "Последние 7 дней"},
                    {value: 1, text: "Последние сутки"},
                ]
            },

            formatDateStartChart() {
                return this.formatDate(this.dateStartChart)
            },

        },
        methods: {
            getDateStartChart() {
                let dt = new Date()
                this.dateStartChart = new Date(dt.setDate(dt.getDate() - this.lastDayActivations))
            },

            getActivationSummary() {
                this.$store.dispatch("Statistic/loadSummary").then((data) => {
                    this.summary = data
                }).catch(err => {
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки сводной информации!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                })
            },

            openDetails(name){
                this.$router.push({name:"StatisticDetails", query:{type:name}})
            }
        },


    }
</script>

<style scoped>
    .summary-card {
        width: 220px;
        height: 100%;
        padding: 10px 5px;
    }

    .summary-card_title {
        font-weight: 600;
        font-size: 20px;
        line-height: 40px;
        align-items: center;
        color: #000000;
    }

    .summary-card_label {
        margin-top: 25px;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        align-items: center;
        color: #6E7C8D;
    }

    .summary-card_text {
        font-weight: 600;
        font-size: 48px;
        line-height: 60px;
        align-items: center;
        color: #000000;
    }

    .pupular-card_title {
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #000000;
    }

    .pupular-card_subtitle {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        align-items: center;
        color: #6E7C8D;
    }

    .popular-card {
        height: 480px;
        display: flex;
        flex-direction: column;
    }

    .activates-card {
        height: 650px;
        display: flex;
        flex-direction: column;
    }

    .activates-card_title {
        font-weight: 600;
        font-size: 20px;
        line-height: 40px;
        color: black;
    }
</style>